import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=0354898b&scoped=true&"
import script from "./setting.vue?vue&type=script&lang=js&"
export * from "./setting.vue?vue&type=script&lang=js&"
import style0 from "./setting.vue?vue&type=style&index=0&id=0354898b&prod&scoped=true&lang=css&"
import style1 from "./setting.vue?vue&type=style&index=1&id=0354898b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0354898b",
  null
  
)

export default component.exports